<div>
  <div class="modal-header">
    <button type="button" class="close" aria-label="Close" (click)="cancel()">
      <span aria-hidden="true">&times;</span>
    </button>
    <h4 class="modal-title">{{selectedMonitorItem?.Name}}</h4>
  </div>
  <div class="form-group modal-body">
    <div>
      <span>Polling interval: </span>{{selectedMonitorItem?.PollingInterval}} second(s)<br />
      <span>Monitor type: </span>{{selectedMonitorItem?.ArtifactName}} <br />
    </div>
    @if (selectedMonitorItem.AbsenceItemTemplate !== null) {
      <div class="panel panel-default panel-body">
        <h1>Monitor paused</h1>
        <h3>Reason: {{selectedMonitorItem.AbsenceItemTemplate?.Note}}</h3>
        <h3>Resumes at: {{getAbsenceExpireDate()}}</h3>
      </div>
    }
    <dx-data-grid id="gridContainer"
      [dataSource]="selectedMonitorItemStatuses"
      [showRowLines]="true"
      [showBorders]="true"
      [rowAlternationEnabled]="true"
      [masterDetail]="{ enabled: true, template: 'detail' }"
      [columnAutoWidth]="true">
      <dxo-selection mode="single"></dxo-selection>
      <dxi-column caption="Status" cellTemplate="monitorItemStatusTemplate" width="100"></dxi-column>
      <div *dxTemplate="let row of 'monitorItemStatusTemplate'">
        @if (row.data.EffectiveStatus != row.data.ReportedStatus) {
          <div ngbTooltip="Effective status" style="display: inline">
            <app-status-traffic-light [status]="row.data.EffectiveStatus"></app-status-traffic-light>
          </div>
        }
        <div ngbTooltip="Reported status" style="display: inline">
          <app-status-traffic-light [status]="row.data.ReportedStatus"></app-status-traffic-light>
        </div>
      </div>
      <dxi-column dataField="StatusDateTime" dataType="date" [format]="dateTimeService.getDevExpressDateTimeFunction" width="155"></dxi-column>
      <dxi-column dataField="Description"></dxi-column>

      <div *dxTemplate="let itemStatus of 'detail'">
        @if (itemStatus.data.StatusLog) {
          <div>
            <div class="group-with-header">
              <div class="group-header">Status Log</div>
              <pre class="line-breaker">{{itemStatus.data.StatusLog}}</pre>
            </div>
          </div>
        }
        @if (!itemStatus.data.StatusLog) {
          <pre class="line-breaker">{{itemStatus.data.Description}}</pre>
        }
      </div>
    </dx-data-grid>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-primary" (click)="cancel()">Close</button>
    @if (canGoToMonitorEdit()) {
      <button type="button" class="btn btn-primary" (click)="goToMonitorEdit()">Edit</button>
    }
    @if ($safeNavigationMigration(selectedMonitorItem?.AbsenceItemTemplate) === null) {
      <button *bizPermissionRequired="'Monitor_Action_Item_Edit'" class="btn btn-primary" (click)="pauseMonitor()">Pause Monitor</button>
    }
    @if ($safeNavigationMigration(selectedMonitorItem?.AbsenceItemTemplate) !== null) {
      <button *bizPermissionRequired="'Monitor_Action_Item_Edit'" class="btn btn-primary" (click)="resumeMonitor()">Resume Monitor</button>
    }
  </div>
</div>
